import { render, staticRenderFns } from "./GoalBlurbs.vue?vue&type=template&id=2364972a&"
import script from "./GoalBlurbs.vue?vue&type=script&lang=js&"
export * from "./GoalBlurbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports